import { Link } from "react-router-dom";
import { Facebook, GraduationCap, Instagram, Linkedin, Mail, MapPin, MessageCircle, Phone, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy-deep border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
        <div className="col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-lg bg-orange-600 flex items-center justify-center">
              <GraduationCap className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <div className="font-display font-extrabold text-white text-sm">XTM TECHNOLOGIES</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-orange-400 font-semibold">FutureSkills Academy</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 mb-4">Enlightening Emerging Technologies. Learn Today. Build Tomorrow.</p>
          <div className="flex flex-wrap gap-2">
            {["ISO 9001:2015 Certified", "MSME Registered", "GST Registered"].map((c) => (
              <span key={c} className="text-[10px] uppercase tracking-wider font-semibold text-slate-300 border border-white/15 rounded-full px-2.5 py-1">{c}</span>
            ))}
          </div>
        </div>
        <FooterCol title="Programs" links={[
          ["IT & ITeS", "/courses/category/it-ites"],
          ["Hardware & Electronics", "/courses/category/hardware-electronics"],
          ["Beauty & Wellness", "/courses/category/beauty-wellness"],
          ["Entrepreneurship & Management", "/courses/category/entrepreneurship-management"],
          ["WILP B.Voc", "/wilp-bvoc"],
          ["AI Accelerator", "/career-programs"],
          ["Tally Education", "/tally-education"],
          ["Internships & Workshops", "/internship"],
        ]} />
        <FooterCol title="Students" links={[
          ["Student Portal", "/portal"],
          ["Admissions", "/admissions"],
          ["Certificate Verification", "/verify"],
          ["Career Pathways", "/career-pathways"],
          ["AI Career Counsellor", "/career-ai"],
          ["Internships & Workshops", "/events"],
        ]} />
        <FooterCol title="Company" links={[
          ["About XTM", "/about"],
          ["Blog / Knowledge Hub", "/blog"],
          ["Contact", "/contact"],
          ["FAQs", "/#faqs"],
        ]} />
        <div>
          <h4 className="font-display font-semibold text-white mb-4 text-sm uppercase tracking-wider">Connect</h4>
          <div className="space-y-3 text-sm text-slate-400">
            <p className="flex gap-2"><MapPin className="w-4 h-4 text-orange-400 shrink-0 mt-0.5" /> Katyayani Building, 3rd Floor, Near Star Media, Tarajan, Jorhat – 785001, Assam</p>
            <a href="tel:+919101380454" className="flex gap-2 hover:text-orange-400 transition-colors" data-testid="footer-phone"><Phone className="w-4 h-4 text-orange-400 shrink-0" /> +91 9101380454</a>
            <a href="mailto:info@xtmtechnologies.in" className="flex gap-2 hover:text-orange-400 transition-colors" data-testid="footer-email"><Mail className="w-4 h-4 text-orange-400 shrink-0" /> info@xtmtechnologies.in</a>
            <a href="https://wa.me/919101380454" target="_blank" rel="noreferrer" className="flex gap-2 hover:text-orange-400 transition-colors" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4 text-orange-400 shrink-0" /> WhatsApp Us</a>
          </div>
          <div className="flex gap-3 mt-4">
            {[Facebook, Instagram, Youtube, Linkedin].map((Icon, i) => (
              <span key={i} className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-slate-400 hover:text-orange-400 hover:border-orange-500/40 transition-colors cursor-pointer" data-testid={`footer-social-${i}`}>
                <Icon className="w-4 h-4" />
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500 px-4">
        © 2026 XTM TECHNOLOGIES, Jorhat — The FutureSkills Academy. Demo records on this site are sample data, not genuine student data or endorsements.
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-display font-semibold text-white mb-4 text-sm uppercase tracking-wider">{title}</h4>
      <ul className="space-y-2.5">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-slate-400 hover:text-orange-400 transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
